(function () {
    //polyfill required here for IE until is can be included in Mosaic's Polyfill
    Number.isNaN = Number.isNaN || function isNaN(input) {
        return typeof input === 'number' && input !== input;
    }
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.carousellayoutblock = window.oneadvanced.carousellayoutblock || {};
    window.oneadvanced.carousellayoutblock.init = function () {
        //console.log("initialising carousellayoutblock...");
        var carouselLayoutBlocks = document.querySelectorAll('[data-clb-block-id]');

        if (carouselLayoutBlocks.length) {
            for (var clb = 0; clb < carouselLayoutBlocks.length; clb++) {
                clbHandler(
                    carouselLayoutBlocks[clb].getAttribute('data-clb-block-id'),
                    carouselLayoutBlocks[clb].getAttribute('data-clb-columns'),
                    carouselLayoutBlocks[clb].getAttribute('data-clb-disableinfinitescrolling')
                );
            }
        }

        function clbHandler(BlockId, no_of_columns, disableInfiniteScrolling) {
            var $carouselLayoutBlock_slider = new Swiper('[data-clb-block-id="' + BlockId + '"]', {
                slidesPerView: 1,
                spaceBetween: 15,
                loop: (disableInfiniteScrolling == 'False'),
                pagination: {
                    el: `.swiper-pagination-${BlockId}`,
                    type: 'bullets',
                    clickable: true,
                },
                navigation: {
                    nextEl: `.swiper-button-next-${BlockId}`,
                    prevEl: `.swiper-button-prev-${BlockId}`,
                },
                breakpoints: {
                    1025: {
                        slidesPerView: no_of_columns
                    },
                    640: {
                        slidesPerView: 2
                    }
                },
                grabCursor: true,
            });            

            // Slick's internal lazyloading isn't compatible with our implementation
            // so use our mutation observer to watch slick for creating clones
            // that will internally add the cloned images to our observer

            //defensive check for window.oneadvanced.observer.mutation_observer
            if (window.oneadvanced.observer.hasLoaded) {
                // Select the node that will be observed for mutations
                var targetNode = document.querySelector('[data-clb-block-id="' + BlockId + '"]');

                // Start observing the target node for configured mutations
                window.oneadvanced.observer.mutation_observer.observe(targetNode,
                    window.oneadvanced.observer.mutation_observer_config);
            } else {
                //console.log("window.oneadvanced.observers has not been loaded. Unable to watch for Mutations.");
            }
        }        
    };
    window.oneadvanced.carousellayoutblock.hasLoaded = true;

})();